export default __webpack_public_path__ + "static/media/special-purhcase-preview.51c9d179.png";